/* eslint-disable */
import axios from "axios";
import store from "../../store/index";
import Multiselect from "@vueform/multiselect";
import { version } from "vuex/dist/vuex.cjs.js";
export default {
  name: "ReconsentCampaignmodal",
  props: {
  consentRecordId: {
    type: String,
    default: ""
  },
  selectedICF: {
    type: Object,
    default: () => ({})
  },
  
},
  components: {
    Multiselect
  },
  data() {
    return {
      token: store.getters.getIdToken,
      baseapi: process.env.VUE_APP_Service_URL,
      studyId: store.getters.getStudyIs,
       allowedFormsList: [],
       selectAllSubjectStatuses: false,
        allowedFormsDuringLock: [],
     selectAllSites: false,
     selectAllArmCodes: false,
     selectAllCohorts: false,
      // dropdown lists
      cohortList: [],
      armList: [],
      sites: [],
      roleList: [],
selectedRoles: [],
      studyDetails: {},
      validations: [true, true, true, true, true, true],
       selectAllCountries: false,
        searchCountry: "",
           errors: {
      campaignName: "",
      version: "",
      enrollmentDate: "",
      status: "",
      applicability: "",
      subjectStatus: ""
    },
    statusList: [
      { label: "Active", value: "Active" },
      { label: "Inactive", value: "Inactive" }
    ],
    subjectStatusList: [],

      // form values
    values: {
      campaignName: "",
      version: "",

  cohortId: "",
  cohortName: "",
  cohortCode: "",
  armCode: "",
  siteId: "",

  countries: [],
  siteIds: [],
  armCodes: [],
  cohorts: [],

  subjectId: "",
  enrollmentDate: "",
  status: "",

  // Subject Selection
 subjectStatuses: [],

  // Workflow Rules
  lockVisits: false,
  requireSignature: false,
  allowRemoteConsent: false,
  freezeList: false,

  allowedFormsDuringLock: [],
  lockMode: "",

  ruleExpression: ""
},
      showCountryDropdown: false,
      selectAllApplicability: false,
      countries: [],

      sectionState: {
        basic: true,
        consent: true
      },
      isSaving: false
    };
  },
  computed: {
  filteredCountries() {
    return this.countries.filter(country =>
      country.name
        .toLowerCase()
        .includes(this.searchCountry.toLowerCase())
    );
  }
},
watch: {
  "values.countries"(val) {
    this.selectAllCountries = this.countries.length > 0 && val.length === this.countries.length;
  },
  "values.siteIds"(val) {
    this.selectAllSites = this.sites.length > 0 && val.length === this.sites.length;
  },
  "values.armCodes"(val) {
    this.selectAllArmCodes = this.armList.length > 0 && val.length === this.armList.length;
  },
  "values.cohorts"(val) {
    this.selectAllCohorts = this.cohortList.length > 0 && val.length === this.cohortList.length;
  },
  "values.subjectStatuses"(val) {
    this.selectAllSubjectStatuses = this.subjectStatusList.length > 0 && val.length === this.subjectStatusList.length;
  },
   selectedICF: {
    immediate: true,
    handler(newVal) {
      if (newVal) {
        this.values.version = newVal.version || "";
      }
    }
  }
},
 async mounted() {
  await Promise.all([
    this.getCohortList(),
    this.getStudyArms(),
    this.getSites(),
    this.getCountries(),
    this.getStudyDetails(),
    this.getAllowedFormsList(),
    this.getRoleList(),
    this.getSubjectStatuses()
  ]);
},
  methods: {
    async getCohortList() {
      const idtoken = this.token;
      try {
        const res = await axios.get(
          `${this.baseapi}/management/cohort/search?StudyId=${this.studyId}`,
          { headers: { Authorization: "Bearer " + idtoken } }
        );
        this.cohortList = res.data.data;
      } catch (err) {
        console.error("Error fetching cohorts", err);
      }
    },

    async getStudyArms() {
      const idtoken = this.token;
      try {
        const res = await axios.get(
          `${this.baseapi}/fhir-service/arm/getarmsbystudyid?study_id=${this.studyId}`,
          { headers: { Authorization: "Bearer " + idtoken } }
        );
        this.armList = res.data;
      } catch (err) {
        console.error("Error fetching arms", err);
      }
    },

    async getSites() {
      const idtoken = this.token;
      try {
        const res = await axios.get(
          `${this.baseapi}/management/site/getallsitesbyuser?studyId=${this.studyId}&getAll=false`,
          { headers: { Authorization: "Bearer " + idtoken } }
        );
        this.sites = res.data;
      } catch (err) {
        console.error("Error fetching sites", err);
      }
    },

    async getCountries() {
      const idtoken = this.token;
      try {
        const res = await axios.get(
          `${this.baseapi}/management/patient/getallcountry`,
          { headers: { Authorization: "Bearer " + idtoken } }
        );
        this.countries = res.data;
      } catch (err) {
        console.error("Error fetching countries", err);
      }
    },

    async getStudyDetails() {
      const idtoken = this.token;
      try {
        const res = await axios.get(
          `${this.baseapi}/management/study/getbyid?id=${this.studyId}`,
          { headers: { Authorization: "Bearer " + idtoken } }
        );
        this.studyDetails = res.data;
      } catch (err) {
        console.error("Error fetching study details", err);
      }
    },

    toggleSection(section) {
      this.sectionState[section] = !this.sectionState[section];
    },

 clearForm() {

  this.selectedRoles = [];
  this.values = {

    campaignName: "",
    version: this.selectedICF?.version || "",
    enrollmentDate: "",
    status: "",
    countries: [],
    siteIds: [],
    armCodes: [],
    cohorts: [],
    cohortId: "",
    cohortName: "",
    cohortCode: "",
    armCode: "",
    siteId: "",
    country: "",
    subjectId: "",
   subjectStatuses: [],
    lockVisits: false,
    requireSignature: false,
    allowRemoteConsent: false,
    freezeList: false,
     allowedFormsDuringLock: [],
    lockMode: "",
    ruleExpression: ""
    
  };
  this.selectAllSubjectStatuses = false;

  this.selectAllApplicability = false;
  this.selectAllCountries = false;
  this.selectAllSites = false;
  this.selectAllArmCodes = false;
  this.selectAllCohorts = false;

  this.errors = {
    campaignName: "",
    version: "",
    enrollmentDate: "",
    status: ""
  };

  this.$forceUpdate();
},
    closeModal() {
      this.$emit("closeModal"); },

toggleAllApplicability() {
  const select = this.selectAllApplicability;
  
  // Countries
  if (this.countries.length) {
    this.values.countries = select ? this.countries.map(c => c.name) : [];
    this.selectAllCountries = select && this.values.countries.length === this.countries.length;
  } else {
    this.selectAllCountries = false;
  }
  
  // Sites
  if (this.sites.length) {
    this.values.siteIds = select ? this.sites.map(s => s.siteID) : [];
    this.selectAllSites = select && this.values.siteIds.length === this.sites.length;
  } else {
    this.selectAllSites = false;
  }
  
  // Arms
  if (this.armList.length) {
    this.values.armCodes = select ? this.armList.map(a => a.ArmCode) : [];
    this.selectAllArmCodes = select && this.values.armCodes.length === this.armList.length;
  } else {
    this.selectAllArmCodes = false;
  }
  
  // Cohorts
  if (this.cohortList.length) {
    this.values.cohorts = select ? this.cohortList.map(c => c.id) : [];
    this.selectAllCohorts = select && this.values.cohorts.length === this.cohortList.length;
  } else {
    this.selectAllCohorts = false;
  }
  
  this.$forceUpdate();
},
async visitLockByPatient(subjectIds = [], activate = false) {

  try {

    console.log(
      "Visit Lock SubjectIds:",
      subjectIds
    );

    const response = await axios.put(

      `${this.baseapi}/management/reconsentcampaign/visitlockbypatient?activate=${activate}`,

      subjectIds,

      {
        headers: {
          Authorization: "Bearer " + this.token,
          "Content-Type": "application/json"
        }
      }
    );

    console.log(
      "Visit Lock Response:",
      response.data
    );

    return response.data;

  } catch (error) {

    console.error(
      "Error in visitlockbypatient API:",
      error
    );

    throw error;
  }
},
async saveReconsentCampaign() {

  this.errors = {
    campaignName: "",
    version: "",
    enrollmentDate: "",
    status: ""
  };

  let isValid = true;

  if (!this.values.campaignName?.trim()) {

    this.errors.campaignName =
      "Campaign name is required";

    isValid = false;
  }

  if (!this.values.version?.trim()) {

    this.errors.version =
      "Version is required";

    isValid = false;
  }

  const hasApplicability =

    (this.values.countries &&
      this.values.countries.length > 0) ||

    (this.values.siteIds &&
      this.values.siteIds.length > 0) ||

    (this.values.armCodes &&
      this.values.armCodes.length > 0) ||

    (this.values.cohorts &&
      this.values.cohorts.length > 0);

  const hasSubjectSelection =

 this.values.subjectStatuses &&
  this.values.subjectStatuses.length > 0;

  if (!hasApplicability && !hasSubjectSelection) {

    alert(
      "Please select at least one option from Applicability or Subject Selection Rules"
    );

    isValid = false;
  }

  if (!isValid) {
    return;
  }

  try {

    this.isSaving = true;

    const payload = {

      StudyId: this.studyId,

      CampaignName:
        this.values.campaignName,

      ICF: {

        ICFID:
          this.selectedICF?.icfId || "",
            ICFDocumentID: this.selectedICF?.icfDocumentID || "",

        ICFName:
          this.selectedICF?.icfName || "",

        Version:
          this.selectedICF?.version || ""
      },

      Status:
        this.values.status || "",

      SelectionCriteria: {

        Countries:
          this.values.countries || [],

        Sites:
          this.values.siteIds || [],

        Arms:
          this.values.armCodes || [],

        Cohorts:
          this.values.cohorts || [],

       SubjectStatuses:
  this.values.subjectStatuses || [],
      },

      WorkflowRules: {

        LockFutureVisits:
          this.values.lockVisits || false,

        AllowedFormsDuringLock: this.values.allowedFormsDuringLock || [],

        RequireInvestigatorSignature:
          this.values.requireSignature || false,

        AllowRemoteConsent:
          this.values.allowRemoteConsent || false,

        AutoUnlockAfterReConsent:
          this.values.freezeList || false,

        VisitLockMode:
          this.values.lockMode || ""
      },
       
     roleIds: this.selectedRoles
  
      
    };

    console.log(
      "Re-Consent Payload:",
      payload
    );

    const response = await axios.post(

      `${this.baseapi}/management/reconsentcampaign/create`,

      payload,

      {
        headers: {

          Authorization:
            "Bearer " + this.token,

          "Content-Type":
            "application/json"
        }
      }
    );

    console.log(
      "Campaign Created:",
      response.data
    );


    const patientIds =
      response?.data?.patientIds || [];

    const patientCount =
      response?.data?.patientCount || 0;


if (
  this.values.lockVisits &&
  patientIds.length > 0
) {

  await this.visitLockByPatient(
    patientIds,
    true
  );
}


    alert(
      `Consent configuration saved successfully.\n${patientCount} subjects have been added to the required consent list for the new ICF form.`
    );

    this.closeModal();

  } catch (error) {

    console.error(
      "Error creating campaign:",
      error
    );

    alert(
      "Failed to create Re-Consent Campaign"
    );

  } finally {

    this.isSaving = false;
  }
},
// async saveReconsentCampaign() {

//   this.errors = {
//     campaignName: "",
//     version: "",
//     enrollmentDate: "",
//     status: ""
//   };

//   let isValid = true;

//   if (!this.values.campaignName?.trim()) {

//     this.errors.campaignName =
//       "Campaign name is required";

//     isValid = false;
//   }

//   if (!this.values.version?.trim()) {

//     this.errors.version =
//       "Version is required";

//     isValid = false;
//   }

//   const hasApplicability =

//     (this.values.countries &&
//       this.values.countries.length > 0) ||

//     (this.values.siteIds &&
//       this.values.siteIds.length > 0) ||

//     (this.values.armCodes &&
//       this.values.armCodes.length > 0) ||

//     (this.values.cohorts &&
//       this.values.cohorts.length > 0);

//   const hasSubjectSelection =

//     this.values.screened ||
//     this.values.enrolled ||
//     this.values.active ||
//     this.values.completed ||
//     this.values.withdrawn;

//   if (!hasApplicability && !hasSubjectSelection) {

//     alert(
//       "Please select at least one option from Applicability or Subject Selection Rules"
//     );

//     isValid = false;
//   }


//   if (!isValid) {
//     return;
//   }

//   try {

//     this.isSaving = true;

//     const payload = {

//       StudyId: this.studyId,

//       CampaignName:
//         this.values.campaignName,

//       ICF: {

//         ICFID:
//           this.selectedICF?.icfId || "",

//         ICFName:
//           this.selectedICF?.icfName || "",

//         Version:
//           this.selectedICF?.version || ""
//       },

//       Status:
//         this.values.status || "",

//       SelectionCriteria: {

//         Countries:
//           this.values.countries || [],

//         Sites:
//           this.values.siteIds || [],

//         Arms:
//           this.values.armCodes || [],

//         Cohorts:
//           this.values.cohorts || [],

//         SubjectStatuses: [

//           ...(this.values.screened
//             ? ["Screened"]
//             : []),

//           ...(this.values.enrolled
//             ? ["Enrolled"]
//             : []),

//           ...(this.values.active
//             ? ["Active"]
//             : []),

//           ...(this.values.completed
//             ? ["Completed"]
//             : []),

//           ...(this.values.withdrawn
//             ? ["Withdrawn"]
//             : [])
//         ]
//       },

//       WorkflowRules: {

//         LockFutureVisits:
//           this.values.lockVisits || false,

//         AllowedFormsDuringLock:
//           this.values.allowedFormsDuringLock
//             ? [this.values.allowedFormsDuringLock]
//             : [],

//         RequireInvestigatorSignature:
//           this.values.requireSignature || false,

//         AllowRemoteConsent:
//           this.values.allowRemoteConsent || false,

//         AutoUnlockAfterReConsent:
//           this.values.freezeList || false,

//         VisitLockMode:
//           this.values.lockMode || ""
//       }
//     };

//     console.log(
//       "Re-Consent Payload:",
//       payload
//     );

//     const response = await axios.post(

//       `${this.baseapi}/management/reconsentcampaign/create`,

//       payload,

//       {
//         headers: {

//           Authorization:
//             "Bearer " + this.token,

//           "Content-Type":
//             "application/json"
//         }
//       }
//     );

//     console.log(
//       "Campaign Created:",
//       response.data
//     );

//     const patientCount =
//   response?.data?.patientCount || 0;

// alert(
//   `Consent configuration saved successfully.\n${patientCount} subjects have been added to the required consent list for the new ICF form.`
// );

//     this.closeModal();

//   } catch (error) {

//     console.error(
//       "Error creating campaign:",
//       error
//     );

//     alert(
//       "Failed to create Re-Consent Campaign"
//     );

//   } finally {

//     this.isSaving = false;
//   }
// },

toggleAllCountries() {
  if (this.countries.length === 0) {
    this.selectAllCountries = false;
    return;
  }
  if (this.selectAllCountries) {
    this.values.countries = this.countries.map(c => c.name);
  } else {
    this.values.countries = [];
  }
},
toggleAllSites() {
  if (this.sites.length === 0) {
    this.selectAllSites = false;
    return;
  }
  if (this.selectAllSites) {
    this.values.siteIds = this.sites.map(s => s.siteID);
  } else {
    this.values.siteIds = [];
  }
},
toggleAllArmCodes() {
  if (this.armList.length === 0) {
    this.selectAllArmCodes = false;
    return;
  }
  if (this.selectAllArmCodes) {
    this.values.armCodes = this.armList.map(arm => arm.ArmCode);
  } else {
    this.values.armCodes = [];
  }
},
toggleAllCohorts() {
  if (this.cohortList.length === 0) {
    this.selectAllCohorts = false;
    return;
  }
  if (this.selectAllCohorts) {
    this.values.cohorts = this.cohortList.map(cohort => cohort.id);
  } else {
    this.values.cohorts = [];
  }
},

 updateSelectAll() {

  this.selectAllCountries =
    this.countries.length > 0 &&
    this.values.countries.length === this.countries.length;

  this.selectAllSites =
    this.sites.length > 0 &&
    this.values.siteIds.length === this.sites.length;

  this.selectAllArmCodes =
    this.armList.length > 0 &&
    this.values.armCodes.length === this.armList.length;

  this.selectAllCohorts =
    this.cohortList.length > 0 &&
    this.values.cohorts.length === this.cohortList.length;
},
async getAllowedFormsList() {

  const idtoken = this.token;

  try {

    const response = await axios.get(
      `${this.baseapi}/forms/template/listtemplate?IsPrivileged=true&StudyID=${this.studyId}&Status=Approved`,
      {
        headers: {
          Authorization: "Bearer " + idtoken
        }
      }
    );

    console.log("Allowed Forms List:", response.data);

    this.allowedFormsList = response.data.results || [];

  } catch (error) {

    console.error(
      "Error fetching allowed forms list",
      error
    );
  }
},
async getRoleList() {
  try {
    const res = await axios.get(`${this.baseapi}/account-core/roles/rolelist`, {
      headers: {
        Authorization: `Bearer ${this.token}`,
        "Content-Type": "application/json",
      }
    });
    this.roleList = res.data;
  } catch (err) {
    console.error("Error getting role list:", err);
  }
},
async getSubjectStatuses() {

  const idtoken = this.token;

  try {

    const res = await axios.get(
      `${this.baseapi}/management/statusmaster/getall?StatusType=Subject`,
      {
        headers: {
          Authorization: "Bearer " + idtoken
        }
      }
    );

    console.log("Subject Status List:", res.data);

    this.subjectStatusList = res.data.filter(
      x => x.active
    );

  } catch (err) {

    console.error(
      "Error fetching subject statuses",
      err
    );
  }
},
toggleAllSubjectStatuses() {
  if (this.selectAllSubjectStatuses) {
    this.values.subjectStatuses =
      this.subjectStatusList.map(x => x.status);
  } else {
    this.values.subjectStatuses = [];
  }
}
  }
};
